import(/* webpackMode: "eager" */ "/home/skillmate/public_html/livekit-meet/frontend/src/app/page.tsx");
